// Theme registry. Each theme = shared metadata (shared/card-themes.json) + art components + CSS.
// Fonts: @font-face rules are cheap; browsers only download a font file when a theme actually uses it.
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/space-grotesk/latin-600.css';
import '@fontsource/space-grotesk/latin-700.css';
import '@fontsource/jetbrains-mono/latin-600.css';
import '@fontsource/black-ops-one/latin-400.css';
import '@fontsource/oswald/latin-500.css';
import '@fontsource/bebas-neue/latin-400.css';
import '@fontsource/fredoka/latin-600.css';
import '@fontsource/tilt-neon/latin-400.css';
import '@fontsource/pirata-one/latin-400.css';
import '@fontsource/orbitron/latin-800.css';
import '@fontsource/russo-one/latin-400.css';

import './fx.css';
import './hexlink.css';
import './skully.css';
import './freedom.css';
import './cockatoo.css';
import './pink.css';
import './demon.css';
import './venom.css';

import meta from '../../../../../shared/card-themes.json';
import {
    HexBackdrop, HexPhotoDecor,
    SkullyBackdrop, SkullyPhotoDecor, Patch,
    FreedomBackdrop, FreedomPhotoDecor,
    CockatooBackdrop, CockatooCrest, CockatooPhotoDecor,
    NeonBackdrop, NeonPhotoDecor,
    DemonBackdrop, DemonPhotoDecor,
    VenomBackdrop, VenomPhotoDecor,
} from './art';

const art = {
    default: { Backdrop: HexBackdrop, PhotoDecor: HexPhotoDecor },
    skully: {
        orgOnPatch: true,
        Backdrop: SkullyBackdrop,
        PhotoDecor: SkullyPhotoDecor,
        // Top patch: nickname (or first name). Bottom patch: organization (the title stays on its own line).
        HeroTop: ({ names }) => <Patch position="top" text={names.nickname || names.firstName} />,
        HeroAfterName: ({ profile }) => <Patch position="bottom" text={profile.organization} />,
    },
    freedom: { Backdrop: FreedomBackdrop, PhotoDecor: FreedomPhotoDecor },
    cockatoo: { Backdrop: CockatooBackdrop, PhotoDecor: CockatooPhotoDecor, HeroTop: CockatooCrest },
    pink: { Backdrop: NeonBackdrop, PhotoDecor: NeonPhotoDecor },
    'grey-demon': { Backdrop: DemonBackdrop, PhotoDecor: DemonPhotoDecor },
    'venom-drip': { Backdrop: VenomBackdrop, PhotoDecor: VenomPhotoDecor },
};

export const THEME_IDS = Object.keys(meta.themes);

export function getTheme(id) {
    const key = meta.themes[id] ? id : 'default';
    return { id: key, ...meta.themes[key], ...art[key] };
}

export const themeList = THEME_IDS.map(getTheme);
